exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result__list[data-v-41db0a7d]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column}.result__list span[data-v-41db0a7d]{margin-bottom:10px}.result__buttons[data-v-41db0a7d]{margin-top:40px}", ""]);

// exports
